"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TourDataViewError = function TourDataViewError() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col pl-8 lg:pl-24"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mb-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.dataview.error.headline"
  })), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.dataview.error.text",
    values: {
      br: /*#__PURE__*/_react["default"].createElement("br", null)
    }
  })));
};

var _default = TourDataViewError;
exports["default"] = _default;